import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    VerificationService,
    SuccessResponse,
    FormFooterComponent,
} from '@sheerid/jslib-nightly';
import { LogoComponent } from '../LogoComponent/LogoComponent';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    <LogoComponent verificationService={verificationService} />
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage= "You are now verified. Below is a one-time registration code that you will use to create an account through our VIP site. Once you have created an account, your discount will be applied automatically to all eligible items on the site. Your exclusive pricing will be available whenever you are logged in to your account.<br><br>Click CONTINUE TO WILSON to begin your registration."/>
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <a href={`https://shop.wilson.com/en-us/vip/account/login/?utm_source=sheerid&utm_medium=referral&utm_campaign=military-verification&cmpid=sheerid|referral|military&accessCode=${rewardCode}`} target="_parent" className="sid-btn sid-btn--dark">
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="CONTINUE TO WILSON" />
                </a>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage="We will email you a copy of your registration code and a link to the website in case you'd prefer to register and shop later. Look for an email from us (verify@sheerid.com) with all the details. Please note that your discount cannot be combined with other offers or promotions."/>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
